var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-analysis"},[_vm._m(0),_c('div',{staticClass:"task-display"},[_c('div',{ref:"chartBox",staticClass:"chart-box"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-title"},[_c('p',[_vm._v("任务图分析")])])
}]

export { render, staticRenderFns }